<div class="filter-container">
  @if (withSearch) {
    <div class="input-container">
      <input
        type="text"
        [placeholder]="placeholder"
        [ngModel]="searchKey"
        (ngModelChange)="onChangeKey($event)"
      />
    </div>
  }
  <div class="chip-container">
    <common-chips
      [options]="filteredOptions"
      [isCommodity]="isCommodity"
      (removeOption)="removeOption($event)"
    ></common-chips>
  </div>
  <div class="options-wrapper d-flex align-items-center flex-wrap">
    <div class="options d-flex flex-wrap" [class.commodity]="isCommodity">
      @for (option of filteredOptions; track option; let i = $index) {
        <div class="d-flex">
          @if (i === 0 && !searchKey) {
            <div class="option-label d-flex align-items-center">
              <label
                class="d-flex align-items-center select-all-wrapper"
                style="cursor: pointer"
              >
                <input
                  type="checkbox"
                  (change)="selectAll($event)"
                  class="d-none"
                />
                @if (isAllSelected()) {
                  <img src="/assets/media/icons/checkbox-checked.svg" />
                } @else {
                  <img src="/assets/media/icons/checkbox-unchecked.svg" />
                }
                <span class="ms-2" i18n="@@global.select-all">Select All</span>
              </label>
            </div>
          }
          <div class="option-label d-flex align-items-center">
            <label class="d-flex align-items-center" style="cursor: pointer">
              <input
                type="checkbox"
                [(ngModel)]="option.selected"
                (change)="updateSelectAll()"
                class="d-none"
              />
              @if (option.selected) {
                <img src="/assets/media/icons/checkbox-checked.svg" />
              } @else {
                <img src="/assets/media/icons/checkbox-unchecked.svg" />
              }
              <span class="ms-2" [title]="option.value">{{
                option.label
              }}</span>
            </label>
          </div>
        </div>
      }
    </div>

    @if (!filteredOptions?.length) {
      <div class="d-flex align-items-center justify-content-center w-100">
        <img src="/assets/media/icons/no-results-filter.svg" alt="no-results" />
      </div>
    }
  </div>
  <div class="action-buttons">
    <div (click)="applyFilters()" class="apply-button">Apply</div>
    <div (click)="clearAll()" class="clear-button">Clear all</div>
  </div>
</div>
